export enum ITEMCLASSTYPE {
  S = 'STANDARD',
  C = 'CUSTOM',
}

export enum ITEMFIELDS {
  I = 'id',
  D = 'description',
  CA = 'category',
  CL = 'classification_type',
  CO = 'companies',
  T = 'type',
  U = 'ui_visible',
}

export enum MODAL_TYPES {
  NEW_PROJ = 'NEW_PROJECT',
  LOCK_FILE = 'LOCK_FILE',
  NEW_DUCT = 'NEW_DUCT',
  NEW_PIPE = 'NEW_PIPE',
  NEW_EQMT = 'NEW_EQUIPMENT',
  DUCT_LENGTH = 'DUCT_LENGTH',
  PIPE_LENGTH = 'PIPE_LENGTH',
  CRCT_DUCT = 'CORRECT_DUCT',
  CRCT_PIPE = 'CORRECT_PIPE',
  CRCT_DLENGTH = 'CORRECT_DUCT_LENGTH',
  CRCT_PLENGTH = 'CORRECT_PIPE_LENGTH',
  CRCT_EQMT = 'CORRECT_EQUIPMENT',
  SUMMARY = 'SUMMARY_VIEW',
  /** project or page deletion confirmation modal! */
  DEL_PAGE = 'DELETE_PAGE_OR_PROJECT_CONFIRM',
  /** Equipment setting for project */
  EQUIPMENT = 'EQUIPMENT_SETTING',
  LEAVE_PAGE = 'LEAVE_CHANGES_CONFIRM',
  CONTACT_US = 'CONTACT_US',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  ADD_GROUP = 'ADD_GROUP',
  ADD_CONTRIBUTORS = 'ADD_CONTRIBUTORS',
  INVITE_NEW_USER = 'INVITE_USER',
  EDIT_GROUP = 'EDIT_COMPANY',
  RESTORE_GROUP = 'ACTIVATE_COMPANY',
  BRUSH_SETTING = 'BRUSH_SETTING',
  DELETE_USER = 'DELETE_USER',
  /** popup Custom Fitting */
  CUSTOM_FITTING = 'CUSTOM_FITTING',
  /** Custom AI MODULE */
  ADD_AI_MODULE = 'ADD_AI_MODULE',
  EDIT_AI_MODULE = 'EDIT_AI_MODULE',
  DELETE_AI_MODULE = 'DELETE_AI_MODULE',
  EDIT_ITEM_AI_MODULE = 'EDIT_ITEM_AI_MODULE',
  ENABLE_AI_MODULE = 'ENABLE_AI_MODULE',
}
